{
  "pt": {
    "ticket_category": {
      "Decisions": "Decisões",
      "Issue": "Pós-Venda",
      "Regular": "Regulares",
      "labels": {
        "ticket_category": "Tipo"
      }
    }
  }
}
